import { Button, ICON_COLOR } from '@zep-us/zus';
import { PlayIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';

/**
 * MobileViewerCTAButtons Props
 */
export interface MobileViewerCTAButtonsProps {
  /** 복사 버튼 클릭 핸들러 */
  onDuplicate: () => void;
  /** 입장 버튼 클릭 핸들러 */
  onEnter: () => void;
}

/**
 * MobileViewerCTAButtons - 모바일용 뷰어 CTA 버튼
 *
 * @description
 * 모바일 하단 고정 영역에 최적화된 뷰어용 2개 CTA 버튼입니다.
 * 가로 배치로 공간 효율성을 높였습니다.
 *
 * @example
 * ```tsx
 * <MobileViewerCTAButtons
 *   onDuplicate={handleDuplicate}
 *   onEnter={handleEnter}
 * />
 * ```
 */
export const MobileViewerCTAButtons = ({
  onDuplicate,
  onEnter
}: MobileViewerCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full gap-sm" data-sentry-component="MobileViewerCTAButtons" data-sentry-source-file="MobileViewerCTAButtons.tsx">
      <Button size="md" intent="gradient" variant="contained" leftSlot={<SquareStackIcon size="sm" fill={ICON_COLOR.inverse} />} onClick={onDuplicate} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerCTAButtons.tsx">
        {t('detail.copyToMyQuiz')}
      </Button>
      <Button size="md" variant="contained" intent="alternative" onClick={onEnter} leftSlot={<PlayIcon size="sm" fill={ICON_COLOR.strong} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerCTAButtons.tsx">
        {t('detail.cta.tutorial')}
      </Button>
    </div>;
};